import { importAll, transformImages } from "utils";

import Gallery from "components/Media/Gallery";
import { Link } from "react-router-dom";
import ReplicaContent from "components/Replicas/ReplicaContent";
import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaSpacer from "components/Replicas/ReplicaSpacer";
import advancedPotionMaking from "assets/replicas/harry-potter/hp-advanced-potion-making/edition-II-prince's-copy";
import advancedPotionMakingV2 from "assets/replicas/harry-potter/hp-advanced-potion-making/edition-II-prince's-copy/v2";
import backgroundImage from "./gallery/promo_02.jpg";
import { routes } from "config";

let gallery = [];
let gallery2 = [];
try {
  gallery = importAll(
    (require as any).context("./gallery", false, /\.(png|jpe?g|svg)$/),
  );
  gallery2 = importAll(
    (require as any).context("./gallery-2", false, /\.(png|jpe?g|svg)$/),
  );
} catch (e) {
  console.warn(e);
}

const background = {
  src: backgroundImage,
  opacity: 0.1,
};

const Page = () => {
  const galleryImages = transformImages(gallery);
  const galleryImages2 = transformImages(gallery2);

  return (
    <ReplicaContent>
      <ReplicaParagraph>
        This is a prototype of the full prop replica of{" "}
        <Link
          to={`/${routes.replicaDetailVersion.slug.replace(":id", advancedPotionMaking.id).replace(":version", `v${advancedPotionMakingV2.version}`)}`}
          target="_blank"
        >
          Advanced Potion-Making v2
        </Link>
        , which was the first piece I made to try out different techniques and
        serve as a proof of concept. The inside of the book is 1:1 with the
        final v2 prop replica, including the endpapers - the only major
        differences from the final product are the edges of the text block.
      </ReplicaParagraph>

      <ReplicaSpacer />
      <Gallery
        images={galleryImages}
        imagesPerRow={3}
        aspectRatio={1}
        imageMaxHeight="200px"
      />
      <ReplicaSpacer />

      <ReplicaParagraph>
        As mentioned above, the prototype is almost the same as the final prop
        with the difference that the text block doesn't have a round spine, but
        a straight one, and the edges' silver foiling is not as crisp as the
        final version. The great thing about this book, though, is that it is
        supposed to be very old and heavily damaged, so even the prototype can
        pass for a believable Prince's Copy.
      </ReplicaParagraph>

      <ReplicaSpacer />
      <Gallery
        images={galleryImages2}
        imagesPerRow={4}
        aspectRatio={1}
        imageMaxHeight="200px"
      />
      <ReplicaSpacer />
    </ReplicaContent>
  );
};

export default Page;
export { background };
